"use strict";

class TransformUtil {
  static transformCoursePersonToSubjectProfiles(coursePersons) {
    let subjectProfiles = [];
    if (coursePersons == null) {
      return subjectProfiles;
    }

    for (let i = 0; i < coursePersons.length; i++) {
      subjectProfiles.push(
        TransformUtil.transformCoursePersonToSubjectProfile(coursePersons[i])
      );
    }

    console.log(">> transformCoursePersonToSubjectProfiles");
    console.log("subjectProfiles: ");
    console.log(subjectProfiles);
    return subjectProfiles;
  }

  static transformCoursePersonToSubjectProfile(coursePerson) {
    console.log(">> transformCoursePersonToSubjectProfile");
    console.log("coursePerson: ");
    console.log(coursePerson);

    let sp = {
      name: coursePerson.name,
      surname: coursePerson.surname,
      birthDate: coursePerson.birthDate,
      gender: coursePerson.gender,
      schoolSkillLevelClient: coursePerson.schoolSkillLevelClient,
      note: coursePerson.note,
    };
    if(coursePerson.language != undefined && coursePerson.language != null) {
      sp.language = coursePerson.language.toUpperCase();
    }

    if (coursePerson.customFormData != undefined && coursePerson.customFormData != null) {
      sp.customFormData = coursePerson.customFormData;
    }

    return sp;
  }

  static transformGroupCourseToGroupCourseIn(groupCourse) {
    if (groupCourse == undefined || groupCourse == null) {
      return null;
    }
    let gcIn = {
      id: groupCourse.id,
      mobVersion: groupCourse.mobVersion,
      appInstance: groupCourse.appInstance,
      mssId: groupCourse.mssId,
      title: groupCourse.title,
      description: groupCourse.description,
      pointMeetingMssId: groupCourse.pointMeetingMssId,
      dateFrom: groupCourse.dateFrom,
      dateTo: groupCourse.dateTo,
      availableCapacity: groupCourse.availableCapacity,
      hoursPerDay: groupCourse.hoursPerDay,
      minLength: groupCourse.minLength,
      allowGroupCourseFlexibleStart: groupCourse.allowGroupCourseFlexibleStart,
    };

    return gcIn;
  }

  static transformGroupCourseLessonsToIn(groupCourseLessons) {
    console.log("transformGroupCourseLessonsToIn");
    if(groupCourseLessons == undefined || groupCourseLessons == null) {
      return [];
    }
    
    let lessons = [];
    for(let i=0; i<groupCourseLessons.length; i++) {
      let l = groupCourseLessons[i];

      let less = {
        id: l.id,
        mobVersion: l.mobVersion,
        appInstance: l.appInstance,
        mssId: l.mssId,
        timeFrom: l.timeFrom,
        timeTo: l.timeTo,
        availableCapacity: l.availableCapacity
      }
      lessons.push(less);
    }


    return lessons;
  }
}

export default TransformUtil;
